import { render, staticRenderFns } from "./datashare.vue?vue&type=template&id=ada47326"
import script from "./datashare.vue?vue&type=script&lang=js"
export * from "./datashare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports